import { AccordionSummary } from '@material-ui/core'
import React from 'react'
import { Body1, SubBody1 } from '@flatsy/core/MaterialUi/Typo/Body'
import StatusInline from '@flatsy/core/Ui/Status/inline'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import theme from '@flatsy/core/MuiTheme/theme'
import { StatusType } from '@flatsy/types/Status'
import { RequiredUploadSubFiles } from '@flatsy/types/Applications'
import i18n from '@flatsy/utils/translations'
import { useStyles } from './Style'
import { FilesListHeaderProps } from './Type'

const FilesListHeader: React.FC<FilesListHeaderProps> = ({
  title,
  description,
  status,
  files,
  required,
}): React.ReactElement => {
  const classes = useStyles()

  const filesCounterStyles = {
    color: status !== StatusType.ERROR ? theme.palette.primary.dark : theme.palette.error.dark,
    backgroundColor:
      status !== StatusType.ERROR ? theme.palette.primary.light : theme.palette.error.light,
  }

  const sideBorderStyle = () => {
    if (status === StatusType.SUCCESS) {
      return { background: theme.palette.success.main }
    }
    if (status === StatusType.ERROR) {
      return { background: theme.palette.error.main }
    }
    if (status === StatusType.WAITING) {
      return { background: theme.palette.warning.main }
    }
    return {}
  }

  const getMinimumFile = (): number => {
    if (required && files[0]) {
      const file = files[0]
      const mainKind = required.find((single) => single.kind === file.main_kind)
      if (mainKind) {
        const kind = mainKind.required.find(
          (single: RequiredUploadSubFiles) => single.kind === file.kind
        )
        if (kind) {
          return kind.min
        }
      }
    }
    return 1
  }

  const getKindStatus = (status: StatusType) => {
    switch (status) {
      case StatusType.ERROR:
        return i18n.t('documents_to_be_replaced')
      case StatusType.SUCCESS:
        return i18n.t('documents_approved')
      case StatusType.WAITING:
        return i18n.t('waiting_for_review')
      case StatusType.WARNING:
        return i18n.t('missing_documents')
      case StatusType.IDLE:
        return ''
      default:
        return status
    }
  }

  return (
    <AccordionSummary className={classes.header}>
      <div className={classes.sideBorder} style={sideBorderStyle()} />
      <div className={classes.headerContainer}>
        <div className={classes.fileContent}>
          <Body1>{title}</Body1>
          <SubBody1 className={classes.headerSubContent}>{description}</SubBody1>
        </div>
        <div className={classes.fileStatus}>
          <StatusInline
            status={status}
            text={getKindStatus(status).toLowerCase()}
            large
            blackTextColor
          />
        </div>
        <div className={classes.headerAction}>
          {files.length ? (
            <>
              <SubBody1 className={classes.counterWrapper} style={filesCounterStyles}>
                {files.length}/{getMinimumFile()}
              </SubBody1>
              <KeyboardArrowDownIcon className={classes.headerArrow} />
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </AccordionSummary>
  )
}

export default FilesListHeader
